import React from 'react'
import RSVPButton from 'components/events/EventButtons/RSVPButton'
import NonMemberNotice from 'components/events/NonMemberNotice'
import ViewRecapButton from 'components/events/EventButtons/ViewRecapButton'
import EnterEventButton, { useShowJoinButton } from './EnterEventButton'
import EventShareButton from 'components/shared/ShareButton/EventShareButton'
import { useEventContext } from 'context/EventContext'
import { faShare } from '@fortawesome/pro-solid-svg-icons'

function EventButtons() {
  const { event } = useEventContext()
  const isVirtualEventRSVPdOrStarted = useShowJoinButton()

  return (
    <div>
      <div className="bg-gradient-to-t from-white h-4 w-full" />

      {isVirtualEventRSVPdOrStarted ? (
        <EnterEventButton />
      ) : (
        <div className="bg-white py-2">
          <div className="flex items-center space-x-4 py-2">
            <EventShareButton
              event={event}
              className="h-full"
              size="lg"
              icon={faShare}
            />

            <div className="flex flex-1 justify-end space-x-2">
              <ViewRecapButton />
              <RSVPButton event={event} className="w-full" />
            </div>
          </div>
          <div className="mx-auto">
            <NonMemberNotice />
          </div>
        </div>
      )}
    </div>
  )
}

export default EventButtons
